import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { IconInfoCircle } from '@tabler/icons-react';

// =============================================================================
// TOOLTIP ICON HELPER
// =============================================================================
const TooltipIcon = ({ tooltip }) => {
  if (!tooltip) return null;
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${Math.random().toString(36).substr(2, 9)}`}>{tooltip}</Tooltip>}
    >
      <span className="d-inline-flex align-items-center ms-1" style={{ cursor: 'help' }}>
        <IconInfoCircle size={16} className="text-muted" />
      </span>
    </OverlayTrigger>
  );
};

export default TooltipIcon;
